import { render, staticRenderFns } from "./DirectSale.vue?vue&type=template&id=47dd344c&scoped=true"
import script from "./DirectSale.vue?vue&type=script&lang=js"
export * from "./DirectSale.vue?vue&type=script&lang=js"
import style0 from "./DirectSale.vue?vue&type=style&index=0&id=47dd344c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dd344c",
  null
  
)

export default component.exports